import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import i18n from '../../i18n';
import { HeaderLink } from './header.interface';

export interface HeaderState {
   breadcrumbs: Array<HeaderLink>;
   tabs: Array<HeaderLink>;
}

const HeaderStore: Module<HeaderState, StoreState> = {
   namespaced: true,
   state: {
      breadcrumbs: [{ to: '/', content: i18n.global.t('app-name') }],
      tabs: [],
   },
   getters: {
      breadcrumbs: (state) => state.breadcrumbs,
      tabs: (state) => state.tabs,
   },
   mutations: {
      SET_BREADCRUMBS(state, breadcrumbs: Array<HeaderLink>) {
         state.breadcrumbs = [{ to: '/', content: i18n.global.t('app-name') }, ...breadcrumbs];
      },
      SET_TABS(state, tabs: Array<HeaderLink>) {
         state.tabs = tabs;
      },
   },
   actions: {},
};

export default HeaderStore;
